import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

import { checkSession, checkOnboarding, checkViewType } from '@/composables/auth';
import { useUserStore } from '@/store/user';
import { useErrorStore } from './store/error';
import { useAppMessageStore } from './store/appmessage';

import TermsDialog from '@/components/shared/TermsDialog.vue';
import TermsCompanyDialog from '@/components/shared/TermsCompanyDialog.vue';

import UploadBox from '@/components/company/UploadBox.vue';
import { watch, onBeforeMount } from 'vue';
import { useCvUploadStore } from '@/store/cvUploads';
import { loadClarity } from '@/utils/clarity';
import i18n from '@/i18n';
import { languageTranslator } from '@/utils/helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const errorStore = useErrorStore();
const appmessageStore = useAppMessageStore();

const userStore = useUserStore();
const cvStore = useCvUploadStore();

checkSession();

function setLocale(selectedLang = null) {
    if (selectedLang) {
        i18n.global.locale = selectedLang;
    } else {
        const availableLocales = i18n.global.availableLocales;
        const userLanguage = window.navigator.language.split('-')[0];
        if (availableLocales.includes(userLanguage)) {
            i18n.global.locale = userLanguage;
        } else {
            i18n.global.locale = 'en';
        }
    }
}

onBeforeMount(() => {
    setLocale();
    loadClarity();
});

watch(
    () => userStore.user,
    (data) => {
        if (data) {
            window.clarity('identify', data.id);
            window.clarity('set', 'email', data.email);
            window.clarity('set', 'userName', data.name);

            const lang = languageTranslator(data?.languageId);
            setLocale(lang);
        }
    }
);

watch(
    () => userStore.currentCompany,
    (data) => {
        if (data) {
            window.clarity('set', 'companyId', data.companyId);
            window.clarity('set', 'companyName', data.companyName);
        }
    }
);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      (!_unref(userStore).fetching)
        ? (_openBlock(), _createBlock(_component_router_view, {
            key: 0,
            name: "top"
          }))
        : _createCommentVNode("", true),
      (!_unref(userStore).fetching)
        ? (_openBlock(), _createBlock(_component_router_view, {
            key: 1,
            name: "left"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_main, { class: "pa-0 font" }, {
        default: _withCtx(() => [
          (_unref(userStore).fetching)
            ? (_openBlock(), _createBlock(_component_v_container, {
                key: 0,
                style: {"height":"100vh"},
                fluid: "",
                class: "pa-0 d-flex justify-center align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    color: "primary",
                    size: "60"
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_container, {
                key: 1,
                fluid: "",
                class: "pa-0 ma-0",
                style: {"height":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_view)
                ]),
                _: 1
              }))
        ]),
        _: 1
      }),
      (_unref(errorStore).$state.error)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 2,
            title: "Errore",
            class: "ma-8",
            position: "fixed",
            "max-width": "320px",
            elevation: "24",
            location: "top right",
            closable: "",
            type: "error",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(errorStore).$state.error), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(appmessageStore).$state.message)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 3,
            title: "",
            class: "ma-8",
            position: "fixed",
            "max-width": "320px",
            elevation: "24",
            location: "top right",
            closable: "",
            type: "success",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(appmessageStore).$state.message), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(TermsDialog),
      _createVNode(TermsCompanyDialog),
      (_unref(cvStore).uploading)
        ? (_openBlock(), _createBlock(UploadBox, { key: 4 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})